import { render, staticRenderFns } from "./jpb_9.vue?vue&type=template&id=3bcd49de&"
import script from "./jpb_9.vue?vue&type=script&lang=js&"
export * from "./jpb_9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports